/**
 * [ File :: G_ImagePushItem.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImagePushItem.js
 * @설명 : 캐릭터에 의해서 밀리는 아이템
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import G_Common from 'canvas/grid/dev/util/G_Common'
import G_Define from 'canvas/grid/dev/util/G_Define'
import G_ImageGrid from 'canvas/grid/dev/child/image/G_ImageGrid';

const G_ImagePushItem = (function () {

	return class extends G_ImageGrid {
		constructor(inputJson) {
			super(inputJson);
		}

		/**
		 * [ Function (protected) :: _pushed ]
		 *
		 * @DES :: 밀려지는 효과
		 * @IP1 :: rotate {num}
		 * @IP2 :: cb {func}
		 * @OUT :: callback {func}
		 * @S.E ::
		 */
		_pushed(rot, cb) {

			// # 가상이동(앞으로)
			this._locateFrontGrid(rot);

			this._checkCrush(
				G_Define.CRUSH_OBJECT_IN_PUSH,
				(
					boolCrush,
				    CRUSH_PATH,
				    CRUSH_OBJECT,
				    CRUSH_VIRTUAL
				) => {

					// /*[T]*/ console.log(boolCrush, CRUSH_PATH, CRUSH_OBJECT, CRUSH_VIRTUAL);

					// # 가상이동(원위치)
					this._locateFrontGrid(G_Common.calRotate("back", rot));

					const ANIMATER = this.CODMOS.ANIMATE;
					const FRONT_PIXEL = this._getFrontPixel(rot, 1); // 이동좌표
					const BACK_PIXEL = [this._pixelX, this._pixelY]; // 회귀좌표

					if (
						!boolCrush
						&&
						CRUSH_PATH[0]
						&&
						!CRUSH_OBJECT[0]
						&&
						!CRUSH_VIRTUAL[0]
					) {
						// [CASE1] 이동
						let newGrid = G_Common.getGrid(this._gridDisX, this._gridDisY, FRONT_PIXEL[0], FRONT_PIXEL[1]);

						// [*] 이부분이 히어로가 움직일지 아닌지를 알려주는 단서입니다.
						this._gridX = newGrid[0]; // Grid를 수정하지만, Pixel은 바꾸지 않습니다.
						this._gridY = newGrid[1]; // Grid를 수정하지만, Pixel은 바꾸지 않습니다.

						// [#] move animate
						ANIMATER._tween.move(this, null, FRONT_PIXEL[0], FRONT_PIXEL[1]);
					}
					else {
						// [CASE2] 충돌

						// [#] crush animate
						ANIMATER._tween.crush(this, null,
							// movePosition
							(FRONT_PIXEL[0] + BACK_PIXEL[0]) / 2, (FRONT_PIXEL[1] + BACK_PIXEL[1]) / 2,
							// backPosition
							BACK_PIXEL[0], BACK_PIXEL[1]);
					}

					// [#] callback
					if (cb) cb();
				});
		}

	}
}());

export default G_ImagePushItem;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImagePushItem.js